import React, { useCallback, useEffect, useRef, useState } from 'react';
import { FlexboxColumn } from '../../../components/action/Flexbox';
import { Line } from '../../../components/action/Line';
import ReviewCardSkeleton from '../../../components/Review/Card/ReviewCardSkelton';
import TwitterReviewCard from '../../../components/Review/Card/TwitterReviewCard';
import ThemedText from '../../../components/theme/ThemedText';
import { apis, CHAINS } from '../../../constants';
import { useBackendApi } from '../../../helpers/backendHelper';
import { usePostSeenTracker } from '../../../hooks/usePostSeenTracker';
import { useGlobalState } from '../../../state/GlobalStateProvider';
import './Tabs.scss';

const TwitterTakes = ({ eligibleProtocols, handleTab, reviewTag, reactionEligible }) => {
  const [{ protocolMapping }] = useGlobalState();
  const backendHelper = useBackendApi();

  const [mainFeed, setMainFeed] = useState([]);
  const [selectedProject, setSelectedProject] = useState();
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [hasMore, setHasMore] = useState(true);

  const pagesLoaded = useRef(new Set());

  const loaderRef = useRef(null);
  const observerRef = useRef(null);

  const { getRefForPost, sendPostSeen } = usePostSeenTracker({
    sendSeenPosts: {
      url: apis.backend.postSeen(),
      fallback: backendHelper.reviews.postSeen,
    },
  });
  //   function resetPagination() {
  //     setMainFeed([]);
  //     setPage(1);
  //     setHasMore(true);
  //     pagesLoaded.current.clear();
  //   }
  const getMainFeed = useCallback(
    async (body = {}, currentPage = 1, reset = false) => {
      if (loading || pagesLoaded.current.has(currentPage)) return;

      setLoading(true);
      try {
        const response = await backendHelper.reviews.getFeed({
          filter: {
            ...body,
            pagination: {
              page: currentPage,
              limit: 5,
            },
            tweetsOnly: true,
          },
        });

        const fetchedFeed = response?.data || [];

        if (reset) {
          setMainFeed(fetchedFeed);
        } else {
          setMainFeed(prev => [...prev, ...fetchedFeed]);
        }

        pagesLoaded.current.add(currentPage);

        if (fetchedFeed.length === 0 || fetchedFeed.length < 5) {
          setHasMore(false);
        }
      } catch (err) {
        console.error('Error fetching feed:', err);
        setHasMore(false);
      } finally {
        setLoading(false);
      }
    },
    [backendHelper, loading],
  );

  function handleProtocol(item) {
    if (String(item?.protocol).startsWith('chain')) {
      return {
        ...item,
        ...(CHAINS[String(item?.protocol).split('-')[1]] || {}),
      };
    }
    return {
      ...item,
      ...(protocolMapping[item?.protocol] || {}),
    };
  }

  useEffect(() => {
    let body = {};
    if (selectedProject) {
      body = { ...body, protocol: selectedProject.value };
    }
    getMainFeed(body, page, page === 1);
  }, [page, selectedProject, getMainFeed]);

  // Intersection Observer Setup
  useEffect(() => {
    if (loading || !hasMore) return;

    const currentLoader = loaderRef.current;
    if (!currentLoader) return;

    const observer = new IntersectionObserver(
      entries => {
        if (entries[0].isIntersecting) {
          setPage(prev => prev + 1);
        }
      },
      {
        rootMargin: '200px',
      },
    );

    observer.observe(currentLoader);
    observerRef.current = observer;

    return () => {
      if (observerRef.current && currentLoader) {
        observerRef.current.unobserve(currentLoader);
      }
    };
  }, [loading, hasMore]);

  return (
    <FlexboxColumn className='feed_wrapper feed_overflow' gap='1.5rem' justifyContent={'flex-start'}>
      {/* <Flexbox className='feed_wrapper_selector'>
        <ThemedText.H2>tweets from your top apps just got taked.</ThemedText.H2>
      </Flexbox> */}

      {mainFeed.length === 0 &&
        loading &&
        Array.from({ length: 4 }).map((_, i) => (
          <>
            <ReviewCardSkeleton key={i} />
            <Line />
          </>
        ))}

      {mainFeed.map(feed => (
        <>
          <TwitterReviewCard key={feed.postId} ref={getRefForPost(feed.postId)} data={feed} reactionEligible={reactionEligible} />
          <Line />
        </>
      ))}

      {loading && hasMore && <ReviewCardSkeleton />}
      {!loading && hasMore && (
        <div ref={loaderRef} className=''>
          <span className='invite_wrapper_loader'></span>
        </div>
      )}
      {!hasMore && (
        <ThemedText.H6 style={{ padding: '1rem' }} color='color-xlight'>
          You’ve reached the end.
        </ThemedText.H6>
      )}
    </FlexboxColumn>
  );
};

export default TwitterTakes;
